import { setCookie } from '../utils/cookie';

export default class DismissibleAlert extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener('close.bs.alert', this.setCookie);

    }

    disconnectedCallback() {
        this.removeEventListener('close.bs.alert', this.setCookie);
    }

    setCookie = () => {
        if (this.cookieName == null) {
            throw ('Cookie name not set. Add a data-cookie-name attribute to element.');
        }

        setCookie(this.cookieName, 'true', this.days);
    }

    get cookieName() {
        return this.dataset.dismissibleId;
    }

    get days() {
        return this.dataset.days || 365;
    }

}

customElements.define('dismissible-alert', DismissibleAlert, { extends: 'div' });